const { MAIN } = require('../../../../common/js/constants/cookies');
const { cookieValues } = require('../../../../common/js/universal/ecosia-user');
const { CONSENT_CATEGORIES } = require('../constants');
const { getNonEssentialValuesOf } = require('../cookies-get');

const resetNonEssential = (cookieString) => {
  let newCookieString = cookieString || '';
  const nonEssentialValues = getNonEssentialValuesOf(MAIN);

  nonEssentialValues.forEach((value) => {
    const cookieValue = cookieValues[value];
    const cookieDefault = cookieValue.default;

    const regex = new RegExp(`${cookieValue.key}=[^:]*`, 'g');
    if (cookieDefault === null) {
      newCookieString = newCookieString
        .replace(regex, '');
      newCookieString = newCookieString.replace(/:$/, '');
    } else {
      newCookieString = newCookieString
        .replace(regex, `${cookieValue.key}=${cookieValue.default}`);
    }
  });

  return newCookieString;
};

module.exports = (consent, cookieString) => {
  if (consent === CONSENT_CATEGORIES.essential) {
    return resetNonEssential(cookieString);
  }

  return cookieString;
};
